import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import "./HomePage.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { trackPromise } from "react-promise-tracker";
import { v4 as uuidv4 } from "uuid";
import AttachFiles from "./File/AttachFiles";
import { useNavigate } from "react-router-dom";
import LoadingIndicator from "../../molecules/LoadingIndicator";
import Confirm from "../../molecules/Confirm";
import Alerts from "../../molecules/Alerts";
import EmployeeInformation from "./Employee/EmployeeInformation";
import BankDetails from "./BankData/BankDetails";
import ViewBankDetailsModal from "./BankData/ViewBankDetailsModal";
import { paymentTypes } from "../../../utils/constants";
import { Container, Row, Button } from "reactstrap";
import { Validate } from "../../../utils/Validator";
import { validateSubmitForm } from "../../../utils/employeeValidation";
import { describeRequestError } from "../../../utils/errorMessages";

import {
  apiSubmitRequest,
  apiGetRequest,
  apiPostBankDetail,
  apiUpdateEmployee,
  apiGetBankDetailFromBIC,
  apiGetBankDetailFromIBAN,
  apiDeleteBankDetail,
  apiDeleteFile,
  apiValidateABARoutingNumber,
  apiGetCalculatedIBAN
} from "../../../utils/queries";

const AlertType = {
  Account: 1,
  BankDetails: 2,
  Files: 3,
};

const Home = (props) => {
  const navigate = useNavigate();
  const [alerts, setAlerts] = useState([]);

  const [employeeLoaded, setEmployeeLoaded] = useState(false);
  const [toggleButton, setToggleButton] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [regNo, setRegNo] = useState("");
  const [isRegNoValid, setIsRegNoValid] = useState(true);
  const [bankAccountNumber, setBankAccountNumber] = useState("");
  const [isBankAccountNumberValid, setIsBankAccountNumberValid] = useState(true);
  const [calculatedIBAN, setCalculatedIBAN] = useState("");
  const [calculatedBankData, setCalculatedBankData] = useState(null);
  const [isABARoutingNumberValid, setIsABARoutningNumberValid] = useState(true);
  const [abaRoutingNumber, setAbaRoutingNumber] = useState("");
  const [enableSubmit, setEnableSubmit] = useState(false);
  const [isBICValid, setIsBICValid] = useState(true);
  const [isCorrespondingBICValid, setIsCorrespondingBICValid] = useState(true);
  const [isFinanceAccount, setIsFinanceAccount] = useState(false);
  const [beneficiaryNameIban, setBeneficiaryNameIban] = useState("");
  const [isIbanValidated, setIsIbanValidated] = useState(false);
  const [isABARoutningNumberValidated, setIsABARoutningNumberValidated] = useState(false);
  const [isRegnoAccountValidated, setIsRegnoAccountValidated] = useState(false);
  const [bankDetailList, setBankDetailList] = useState([]);
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [keepThisOnly, setKeepThisOnly] = useState(false);
  const priorityOrder = ["USD", "SGD", "EUR", "DKK"];
  const defaultCurrency = isFinanceAccount
    ? priorityOrder[3]
    : priorityOrder[0];
  const accountNumberLength = 10;
  const [currency, setCurrency] = useState(defaultCurrency);
  const [isBicValidated, setIsBicValidated] = useState(false);
  const [countryCode, setCountryCode] = useState("");
  const [showRegNo, setShowRegNo] = useState(false);
  const [beneficiaryNameSwift, setBeneficiaryNameSwift] = useState("");
  const [availableCurrencyList, setAvailableCurrencyList] = useState([]);
  const [selectedBankDetail, setSelectedBankDetail] = useState({});
  const [toggleConfirmDelete, setToggleConfirmDelete] = useState(false);
  const [toggleConfirmSubmit, setToggleConfirmSubmit] = useState(false);
  const [request, setRequest] = useState({});
  const [employee, setEmployee] = useState(null);
  const [fileList, setFileList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [fullCurrencyList, setFullCurrencyList] = useState([]);
  const [currencyList, setCurrencyList] = useState([]);
  const [paymentTermList, setPaymentTermList] = useState([]);
  const [showAccountFileRequiredError, setShowAccountFileRequiredError] = useState(false);
  const [paymentType, setPaymentType] = useState(null);
  const [purpose, setPurpose] = useState(null);
  const priorityPurpose = ["All", "Expenditure", "Payroll"];
  const [purposeOption, setPurposeOption] = useState(

    priorityPurpose.map((p) => ({ label: p, value: p }))
  );
  const [accountType, setAccountType] = useState("");
  const accountTypeOptions = [
    { label: "Checking", value: "Checking" },
    { label: "Savings", value: "Savings" }
  ];
  const accountNumberPattern = /[^a-zA-Z0-9 ]/g;
  const beneficiaryPattern = /[^a-zA-Z0-9 (),.&]/g;
  const sortedCurrencyList = availableCurrencyList.slice().sort((a, b) => {
    const orderMap = { USD: 0, SGD: 1, EUR: 2, DKK: 3 };
    return (orderMap[a.name] ?? Infinity) - (orderMap[b.name] ?? Infinity);
  });

  const sortedCountryList = countryList.slice().sort((a, b) => {
    const countryOrderMap = {
      "DENMARK": 0,
      "SINGAPORE": 1,
      "UNITED STATES": 2
    };
    const aOrder = countryOrderMap[a.countryName] ?? Infinity;
    const bOrder = countryOrderMap[b.countryName] ?? Infinity;
    return aOrder - bOrder;
  });


  const addAlert = (message, color, timeout = 7000) => {
    let id = uuidv4();
    setAlerts((prev) => [
      ...prev,
      { message: message, id: id, color: color, timeout: timeout },
    ]);
  };


  const { register, handleSubmit, formState: { errors }, setError, setValue, clearErrors, reset, watch, getValues, trigger
  } = useForm({
    defaultValues: {
      type: paymentType,
      currencyId: availableCurrencyList.find((c) => c.currencyCode === currency)?.id,
    },
  });


  let { token } = useParams();
  useEffect(() => {
    async function getRequest() {
      try {
        setEmployeeLoaded(false);
        const request = await apiGetRequest(token);

        if (request.data.request.formSubmitted === true) {
          navigate("/complete");
          return;
        }

        setRequest(request.data.request || {});
        setBankDetailList(request.data.bankDataList || []);
        setFileList(request.data.files);
        setCountryList(request.data.countryList);
        setPaymentTermList(request.data.paymentTermList);
        setFullCurrencyList(request.data.currencyList);
        setIsFinanceAccount(request.data.isFinanceAccount);
        updateCurrencyList(
          request.data.bankDataList,
          request.data.currencyList
        );

        setAvailableCurrencyList(request.data.currencyList || []);

        const emp = request.data.employee;
        if (emp) {
          setEmployee(emp);

          setValue("firstName", emp.firstName || "");
          setValue("lastName", emp.lastName || "");
          setValue("privateEmail", emp.privateEmail || "");
          setValue("privatePhone", emp.privatePhone || "");
          setValue(
            "countryCallingCode",
            emp.countryCallingCode ? emp.countryCallingCode.toString() : ""
          );
          setValue("addressLine1", emp.addressLine1 || "");
          setValue("addressLine2", emp.addressLine2 || "");
          setValue("city", emp.city || "");
          setValue("zip", emp.zip || "");

          let resolvedCountryId = null;
          let resolvedIsoCode = emp.isoCountryCode || "";
          if (emp.country) {
            const countries = request.data.countryList || [];
            const asId = parseInt(emp.country, 10);
            let match = null;
            if (!isNaN(asId)) {
              match = countries.find((c) => c.id === asId);
            }
            if (!match) {
              const name = emp.country.toString().trim().toLowerCase();
              match = countries.find(
                (c) => (c.countryName || "").toLowerCase() === name
              );
            }
            if (match) {
              resolvedCountryId = match.id;
              if (!resolvedIsoCode) {
                resolvedIsoCode = match.countryCodeAlpha2 || "";
              }
            }
          }
          setValue("country", resolvedCountryId ? resolvedCountryId.toString() : "");
          setValue("isoCountryCode", resolvedIsoCode);
          if (resolvedCountryId) {
            setSelectedCountry(resolvedCountryId);
          }
        }

        setEmployeeLoaded(true);
      } catch (error) {
        console.error("Failed to load employee form:", error);
        navigate(`/tokenfail`, {
          state: {
            message: describeRequestError(error),
            token,
            origin: "load-form",
          },
          replace: true,
        });
      }
    }
    getRequest();
  }, []);


  useEffect(() => {
    updateCurrencyList(bankDetailList, fullCurrencyList);
  }, [bankDetailList]);


  const updateCurrencyList = (bankDataInfo, fullCurrencyList) => {
    setCurrencyList(fullCurrencyList);
  };


  // Watch employee information fields
  const firstName = watch("firstName");
  const lastName = watch("lastName");
  const privateEmail = watch("privateEmail");
  const privatePhone = watch("privatePhone");
  const countryCallingCode = watch("countryCallingCode");
  const addressLine1 = watch("addressLine1");
  const addressLine2 = watch("addressLine2");
  const city = watch("city");
  const zip = watch("zip");
  const country = watch("country");
  const countryCodeAlpha3 = watch("isoCountryCode");


  useEffect(() => {
    setShowAccountFileRequiredError(false);
    // Enable submit button if all requirements are met
    const hasEmployeeInfo = firstName?.trim() && lastName?.trim() && privateEmail?.trim() && privatePhone?.trim();
    const hasBankData = bankDetailList.length > 0;
    const hasFiles = fileList?.length > 0;

    if (hasEmployeeInfo && hasBankData && hasFiles) {
      setToggleButton(true);
    } else {
      setToggleButton(false);
    }
  }, [fileList, bankDetailList, firstName, lastName, privateEmail, privatePhone]);


  useEffect(() => {
    setShowAccountFileRequiredError(false);
  }, [fileList]);


  // Reset form fields when payment type changes
  useEffect(() => {
    if (paymentType !== null) {
      // Reset all form fields
      setBeneficiaryNameIban("");
      setBeneficiaryNameSwift("");
      setRegNo("");
      setBankAccountNumber("");
      setCountryCode("");
      setAbaRoutingNumber("");
      setEnableSubmit(false);
      setIsIbanValidated(false);
      setIsABARoutningNumberValidated(false);
      setIsRegnoAccountValidated(false);
      setIsBicValidated(false);
      setIsBankAccountNumberValid(true);
      setIsRegNoValid(true);
      setIsBICValid(true);
      setIsCorrespondingBICValid(true);
      setIsABARoutningNumberValid(true);
      setCalculatedIBAN("");
      setCalculatedBankData(null);
      setPurpose("");
      setAccountType("");
      reset();
    }
  }, [paymentType]);


  const completeForm = async () => {
    setIsSubmitting(true);
    try {
      const selectedCountryObj = country
        ? sortedCountryList.find((c) => c.id === parseInt(country))
        : null;

      const updatedRequest = {
        ...request,
        employee: {
          firstName: firstName,
          lastName: lastName,
          privateEmail: privateEmail,
          privatePhone: privatePhone,
          countryCallingCode: countryCallingCode,
          addressLine1: addressLine1,
          addressLine2: addressLine2,
          city: city,
          zip: zip,
          country: selectedCountryObj?.countryName ?? employee?.country ?? "",
          isoCountryCode:
            countryCodeAlpha3 ?? employee?.isoCountryCode ?? "",
        },
      };
      await apiUpdateEmployee(updatedRequest, token);
      await apiSubmitRequest(token);
      navigate(`/complete`);
    } catch (error) {
      console.error("completeForm failed:", error);
      // Surface server-side validation errors (HTTP 400 with { errors: [...] })
      const responseErrors = error?.response?.data?.errors;
      if (Array.isArray(responseErrors) && responseErrors.length > 0) {
        const alreadySubmitted = responseErrors.some((e) =>
          (e?.message || "").toLowerCase().includes("already been submitted"));
        if (alreadySubmitted) {
          navigate(`/complete`);
          return;
        }
        responseErrors.forEach((e) => addAlert(e.message || "Invalid value.", "danger"));
        return;
      }
      addAlert(
        "Failed to submit form. Please try again. " + (error?.message || error),
        "danger"
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  // Pre-flight validation + confirmation gate for the Submit Form action.
  // The actual completion runs in `completeForm` above, triggered by the
  // <Confirm> modal's onConfirm.
  const onSubmitClick = () => {
    if (isSubmitting) return;

    const selectedCountryObj = country
      ? sortedCountryList.find((c) => c.id === parseInt(country))
      : null;

    const errors = validateSubmitForm({
      firstName,
      lastName,
      privateEmail,
      privatePhone,
      countryCallingCode,
      addressLine1,
      city,
      zip,
      country: selectedCountryObj?.countryName ?? employee?.country ?? "",
      isoCountryCode: countryCodeAlpha3 ?? employee?.isoCountryCode ?? "",
      bankDataCount: bankDetailList?.length ?? 0,
      fileCount: fileList?.length ?? 0,
    });

    if (errors.length > 0) {
      errors.forEach((message) => addAlert(message, "danger"));
      return;
    }

    setToggleConfirmSubmit(true);
  };


  const onCurrencyChanged = (e) => {
    const selectedCurrencyId = e.target.value;
    const selectedCurrency = availableCurrencyList.find(c => c.id == selectedCurrencyId);
    setCurrency(selectedCurrency?.currencyCode || "");
  };


  const handleOnChangeRegistrationNo = (e) => {
    const value = e.target.value;
    setRegNo(value);
    setIsRegNoValid(value.trim() !== "");
  };


  const handleAccountNo = (e) => {
    const raw = e.target.value || "";
    const hasHyphen = raw.indexOf("-") !== -1;
    if (hasHyphen) {
      setIsBankAccountNumberValid(false);
    } else {
      clearErrors && clearErrors("bankAccountNumber");
    }
    const value = raw.toString().replace(accountNumberPattern, "");
    setBankAccountNumber(value);
    if (!hasHyphen) {
      setIsBankAccountNumberValid(value.trim() !== "");
    }
  };


  const onBeneficiaryNameChangeSwift = (e) => {
    const input = e.target.value || "";
    const value = input.toString().replace(beneficiaryPattern, "");
    e.target.value = value;
    setBeneficiaryNameSwift(value);
  };


  const onGetBIC = async () => {
    try {
      setAlerts([]);
      setIsBankAccountNumberValid(true);
      setIsRegNoValid(true);
      setIsBICValid(true);
      setIsCorrespondingBICValid(true);

      const currentValues = {
        bankAccountNumber: document.querySelector('input[name="bankAccountNumber"]')?.value,
        bic: document.querySelector('input[name="bic"]')?.value,
        correspondingBic: document.querySelector('input[name="correspondingBic"]')?.value,
      };

      const missingFields = Validate.requiredFieldsForSwift(
        currency,
        currentValues.bankAccountNumber,
        currentValues.bic,
        beneficiaryNameSwift
      );
      if (missingFields.length > 0) {
        const missingFieldsText = missingFields.join(", ");
        addAlert(`Please fill in the following required fields before validating SWIFT: ${missingFieldsText}`, "error");
        return;
      }

      const requiredFields = Validate.swiftBicRequiredFields(
        currentValues.bankAccountNumber,
        currentValues.bic,
        regNo,
        showRegNo
      );

      if (!requiredFields.isValid) {
        if (requiredFields.invalidFields.includes("bankAccountNumber")) {
          setIsBankAccountNumberValid(false);
        }
        if (requiredFields.invalidFields.includes("regNo")) {
          setIsRegNoValid(false);
        }
        if (requiredFields.invalidFields.includes("bic")) {
          setIsBICValid(false);
        }
        return;
      }

      // const correspondingBic = Validate.correspondingBicNoNumbers(currentValues.correspondingBic);
      // if (!correspondingBic.isValid) {
      //   addAlert(correspondingBic.message, "error");
      //   setIsCorrespondingBICValid(false);
      //   return;
      // }

      const accountNumber = currentValues.bankAccountNumber?.trim();
      const swift = currentValues.bic?.trim();
      const correspondingBicSwift = currentValues.correspondingBic?.trim();
      const swiftValue = Validate.swiftDifferentValues(accountNumber, swift, correspondingBicSwift);
      if (!swiftValue.isValid) {
        addAlert(swiftValue.message, "error");
        return;
      }

      const result = await apiGetBankDetailFromBIC(
        currentValues.bankAccountNumber,
        currentValues.bic,
        token
      );

      const bicdata = result.data.bicdata === null ? {} : result.data.bicdata;

      setIsBICValid(result.data.isBICValid);
      setIsBicValidated(result.data.isBICValid);
      setEnableSubmit(result.data.isBICValid);

      if (result.data.isBICValid) {
        // Auto-fill bank data fields from BIC validation
        setValue("bankName", bicdata.institutionName || "");
        setValue("branch", bicdata.branchName || "");
        setValue("bankAddress", (bicdata.opAddress || "").replace(/[,\s]+$/, ""));
        setValue("bankCity", bicdata.opCity || "");
        setValue("bankZip", bicdata.opZipCode || "");
        setValue("bankCountry", bicdata.countryName || "");

        const countryCode = bicdata.countryIso || bicdata.isoCountryCode || bicdata.countryCode || "";
        setCountryCode(countryCode);  // Bank countryCode (3-letter)

        addAlert("Validated Beneficiary Bank SWIFT BIC successfully. Please remember to click the Add Bank Data button", "success");
      } else {
        addAlert("Error validating Beneficiary Bank SWIFT BIC. Please enter a valid Beneficiary Bank SWIFT BIC number and try again.", "error");
      }
    } catch (error) {
      console.error("Error validating SWIFT:", error);
      addAlert("Error validating SWIFT: ", + error, "error");
      setIsBICValid(false);
      setIsBicValidated(false);
      setEnableSubmit(false);
    }
  };


  const onGetABARoutingNumber = async () => {
    try {
      setAlerts([]);
      setIsABARoutningNumberValidated(false);

      const currentValue = {
        abaRoutingNumber: document.querySelector('input[name="abaRoutingNumber"]')?.value,
      };

      // Check for missing required fields using Validator
      const missingFields = Validate.requiredFieldsForABAValidation(
        currentValue.abaRoutingNumber
      );

      if (missingFields.length > 0) {
        const missingFieldsText = missingFields.join(", ");
        addAlert(`Please fill in the following required fields before validating ABA Routing Number: ${missingFieldsText}`, "error");
        return;
      }

      const result = await apiValidateABARoutingNumber(
        currentValue.abaRoutingNumber,
        token
      );

      setIsABARoutningNumberValidated(result.data.isABARoutingNumberValid);
      setEnableSubmit(result.data.isABARoutingNumberValid);
      setIsBankAccountNumberValid(result.data.isABARoutingNumberValid);
      if (result.data.isABARoutingNumberValid) {

        const bankDetail = result.data.bankData;
        setValue("bankName", bankDetail.bankName || "");
        setValue("bankCity", bankDetail.city || "");
        setValue("state", bankDetail.state || "");
        setValue("bankZip", bankDetail.zipCode || "");
        setValue("bankCountry", bankDetail.country || "USA");
        setValue("county", bankDetail.county || "");
        setValue("timezone", bankDetail.timezone || "");
        setValue("bankAddress", bankDetail.streetAddress || "");
        // Note: bankAccountNumber should be entered by user, not from validation response

        addAlert("Validated ABA Routing Number successfully. Please remember to click the Add Bank Data button.", "success");
      } else {
        addAlert(result.data.message || "Invalid ABA Routing Number. Please try again.", "error");
        setIsABARoutningNumberValid(false);
      }
    } catch (error) {
      addAlert("Error validating ABA Routing Number. Please try again." + error, "error");
    }
  };


  const onValidateRegnoAccount = async () => {
    try {
      setAlerts([]);
      setIsRegnoAccountValidated(false);
      setIsRegNoValid(true);
      setIsBankAccountNumberValid(true);

      const missingFields = Validate.requiredFieldsForRegnoAccount(
        regNo,
        bankAccountNumber
      );

      if (missingFields.length > 0) {
        const missingFieldsText = missingFields.join(", ");
        addAlert(`Please fill in the following required fields before validating REGNO/ACCOUNT: ${missingFieldsText}`, "error");
        return;
      }

      // Validate field formats
      if (regNo.trim().length !== 4) {
        addAlert("Registration number must be exactly 4 digits.", "error");
        setIsRegNoValid(false);
        return;
      }

      if (bankAccountNumber.trim().length !== 10) {
        addAlert("Account number must be exactly 10 digits.", "error");
        setIsBankAccountNumberValid(false);
        return;
      }

      // Calculate IBAN and fetch bank details
      const result = await apiGetCalculatedIBAN(regNo, bankAccountNumber, token, "DK");

      if (result.data && result.data.bankData && result.data.bankData.iban) {
        setCalculatedIBAN(result.data.bankData.iban);
        setCalculatedBankData(result.data.bankData);
        setIsRegnoAccountValidated(result.data.isIBANValid);
        setEnableSubmit(result.data.isIBANValid);

        if (result.data.isIBANValid) {
          // Auto-fill bank data fields
          setValue("iban", result.data.bankData.iban || "");
          setValue("bankName", result.data.bankData.bank || "");
          setValue("bankAddress", result.data.bankData.address || "");
          setValue("bankCity", result.data.bankData.city || "");
          setValue("bankZip", result.data.bankData.zip || "");
          setValue("bankCountry", result.data.bankData.country || "");
          setValue("bic", result.data.bankData.bic || "");
          setCountryCode(result.data.bankData.countryIso || "DK");

          addAlert("Validated Registration Number and Account Number successfully. Please remember to click the Add Bank Data button.", "success");
        } else {
          addAlert("Could not validate Registration Number and Account Number. Please verify the numbers.", "error");
          setEnableSubmit(false);
        }
      } else {
        addAlert("Could not look up bank details for the supplied registration number and account number. Please verify both values and try again.", "error");
        setEnableSubmit(false);
      }
    } catch (error) {
      console.error("Error validating Regno/Account:", error);
      addAlert("Error validating Registration Number and Account Number. Please try again.", "error");
      setIsRegnoAccountValidated(false);
      setEnableSubmit(false);
    }
  };


  const onGetIBAN = async () => {
    try {
      setAlerts([]);
      setIsBankAccountNumberValid(true);
      setIsRegNoValid(true);
      setIsIbanValidated(false);

      const currentValues = {
        bankAccountNumber: document.querySelector('input[name="bankAccountNumber"]')?.value,
      };

      const missingFields = Validate.requiredFieldsForIban(
        currentValues.bankAccountNumber,
        beneficiaryNameIban,
        purpose,
        currency
      );
      if (missingFields.length > 0) {
        const missingFieldsText = missingFields.join(", ");
        addAlert(`Please fill in the following required fields before validating IBAN: ${missingFieldsText}`, "error");
        return;
      }

      // Update state with the validated IBAN value
      setBankAccountNumber(currentValues.bankAccountNumber);

      //   if (showRegNo) {
      //     const registrationNumber = Validate.required(regNo?.trim(), "Registration Number");
      //     if (!registrationNumber.isValid) {
      //       addAlert(registrationNumber.message, "error");
      //       setIsRegNoValid(false);
      //       return;
      //     }
      //   }

      const iban = Validate.noHyphens(currentValues.bankAccountNumber, "IBAN Account Number");
      if (!iban.isValid) {
        addAlert(iban.message, "error");
        setIsBankAccountNumberValid(false);
        return;
      }

      const result = await apiGetBankDetailFromIBAN(
        currentValues.bankAccountNumber,
        token
      );

      setIsBankAccountNumberValid(result.data.isIBANValid);
      setEnableSubmit(result.data.isIBANValid);
      setIsRegNoValid(true);
      setIsIbanValidated(result.data.isIBANValid);

      if (result.data.isIBANValid) {
        // Auto-fill all the bank data fields from IBAN validation
        const bankDetail = result.data.bankData;
        setValue("bic", bankDetail.bic);
        setValue("bankName", bankDetail.bank);
        setValue("branch", bankDetail.branch);
        setValue("bankAddress", bankDetail.address);
        setValue("bankCity", bankDetail.city);
        setValue("bankZip", bankDetail.zip);
        setValue("bankCountry", bankDetail.country);

        const countryCode = bankDetail.countryIso || bankDetail.isoCountryCode || bankDetail.countryCode || "";
        setCountryCode(countryCode);  // Bank countryCode (3-letter)

        addAlert("Validated IBAN Account Number successfully. Please remember to click the Add Bank Data button.", "success");
      } else {
        addAlert(result.data.message || "Invalid IBAN. Please try again.", "error");
        setIsBankAccountNumberValid(false);
      }
    } catch (error) {
      console.error("Error validating IBAN:", error);
      addAlert("Error validating IBAN. Please try again." + error, "error");
      setIsBankAccountNumberValid(false);
      setEnableSubmit(false);
      setIsIbanValidated(false);
    }
  };


  const resetMetadata = () => {
    setEnableSubmit(false);
    setIsBICValid(true);
    setIsCorrespondingBICValid(true);
    setIsIbanValidated(false);
    setIsBicValidated(false);
  };


  const onBeneficiaryNameChangeIban = (e) => {
    const input = e.target.value || "";
    const value = input.toString().replace(beneficiaryPattern, "");
    e.target.value = value;
    setBeneficiaryNameIban(value);
  };


  // True when `candidate` would collide with an entry already present in
  // `bankDetailList`. Mirrors the server-side rule in
  // Hafnia.Employee.Data/Validation/BankDataValidator.cs:
  //   - Same Type AND
  //   - Same identifier (IBAN / BIC+account / RegNo+account / ABA+account) AND
  //   - Same currency (REGNO/ACCOUNT is currency-locked, so currency is implicit)
  const isDuplicateBankEntry = (candidate) => {
    if (!candidate || !Array.isArray(bankDetailList)) return false;
    const norm = (s) => (s ?? "").toString().trim().toLowerCase();

    return bankDetailList.some((existing) => {
      if (!existing || norm(existing.type) !== norm(candidate.type)) return false;

      switch ((candidate.type || "").toUpperCase()) {
        case paymentTypes.IBAN:
          return norm(existing.iban) === norm(candidate.iban)
            && existing.currencyId === candidate.currencyId;
        case paymentTypes.SWIFT: // "BIC"
          return norm(existing.bic) === norm(candidate.bic)
            && norm(existing.bankAccountNumber) === norm(candidate.bankAccountNumber)
            && existing.currencyId === candidate.currencyId;
        case paymentTypes.REGNOACCOUNT:
          return norm(existing.regNo) === norm(candidate.regNo)
            && norm(existing.bankAccountNumber) === norm(candidate.bankAccountNumber);
        case paymentTypes.ABARoutingNumber:
          return norm(existing.abaRoutingNumber) === norm(candidate.abaRoutingNumber)
            && norm(existing.bankAccountNumber) === norm(candidate.bankAccountNumber)
            && existing.currencyId === candidate.currencyId;
        default:
          return false;
      }
    });
  };


  const addBankData = async () => {
    if (paymentType !== paymentTypes.ABARoutingNumber && !purpose) {
      addAlert("Please select a purpose from the dropdown before adding a bank detail.", "error");
      return;
    }

    const bankDetail = {
      type: paymentType,
      regNo: regNo,
      token: token,
      requestId: request.Id || request.id,
    };

    if (paymentType === paymentTypes.REGNOACCOUNT) {
      bankDetail.bankAccountNumber = bankAccountNumber;
      if (calculatedIBAN) {
        bankDetail.iban = calculatedIBAN;
      }
      if (calculatedBankData) {
        bankDetail.bank = calculatedBankData.bank;
        bankDetail.address = calculatedBankData.address;
        bankDetail.city = calculatedBankData.city;
        bankDetail.zip = calculatedBankData.zip;
        bankDetail.bic = calculatedBankData.bic;
        bankDetail.country = calculatedBankData.country;
        bankDetail.countryCode = calculatedBankData.countryIso;
      }
      // Set default currency to DKK for Danish accounts
      const dkkCurrency = availableCurrencyList.find(c => c.currencyCode === "DKK");
      if (dkkCurrency) {
        bankDetail.currencyId = dkkCurrency.id;
      }
      bankDetail.purpose = purpose;

    } else if (paymentType === paymentTypes.IBAN) {
      const formValues = getValues();
      bankDetail.bankAccountNumber = bankAccountNumber;
      bankDetail.iban = bankAccountNumber;
      bankDetail.beneficiaryBankAccountName = beneficiaryNameIban?.trim();
      bankDetail.bic = formValues.bic || "";
      bankDetail.bank = formValues.bankName || "";
      bankDetail.branch = formValues.branch || "";
      bankDetail.address = formValues.bankAddress || "";
      bankDetail.city = formValues.bankCity || "";
      bankDetail.zip = formValues.bankZip || "";
      bankDetail.country = formValues.bankCountry || "";
      bankDetail.countryCode = countryCode;
      bankDetail.purpose = purpose;
      bankDetail.currencyId = formValues.currencyId || "";

    } else if (paymentType === paymentTypes.SWIFT) {
      const formValues = getValues();
      bankDetail.bankAccountNumber = bankAccountNumber;
      bankDetail.beneficiaryBankAccountName = beneficiaryNameSwift?.trim();
      bankDetail.bic = formValues.bic || "";
      bankDetail.correspondingBIC = formValues.correspondingBic || null;
      bankDetail.countryCode = countryCode;
      bankDetail.bank = formValues.bankName || "";
      bankDetail.branch = formValues.branch || "";
      bankDetail.address = formValues.bankAddress || "";
      bankDetail.city = formValues.bankCity || "";
      bankDetail.zip = formValues.bankZip || "";
      bankDetail.country = formValues.bankCountry || "";
      bankDetail.purpose = purpose;
      bankDetail.currencyId = formValues.currencyId || "";

    } else if (paymentType === paymentTypes.ABARoutingNumber) {
      const formValues = getValues();
      bankDetail.abaRoutingNumber = formValues.abaRoutingNumber || "";
      bankDetail.accountType = accountType;
      bankDetail.countryCode = formValues.countryCode || "";
      bankDetail.currencyId = formValues.currencyId || "";
      bankDetail.bankAccountNumber = formValues.bankAccountNumber || "";
      bankDetail.beneficiaryBankAccountName = formValues.beneficiaryBankAccountName || "";
      bankDetail.bank = formValues.bankName || "";
      bankDetail.branch = formValues.branch || "";
      bankDetail.address = formValues.bankAddress || "";
      bankDetail.city = formValues.bankCity || "";
      bankDetail.zip = formValues.bankZip || "";
      bankDetail.country = formValues.bankCountry || "";
      bankDetail.purpose = purpose;
    }

    if (!validateForm(bankDetail)) {
      return;
    }

    if (isDuplicateBankEntry(bankDetail)) {
      addAlert(
        "A bank account with the same details has already been added. Please remove the existing entry or change the currency.",
        "danger"
      );
      return;
    }

    try {
      const result = await trackPromise(apiPostBankDetail(bankDetail, token));
      const newBankData = result.data.bankData || result.data;
      setBankDetailList([...bankDetailList, newBankData]);

      addAlert("Bank data added successfully!", "success");

      // Reset form after successful submission
      setKeepThisOnly(false);
      setBeneficiaryNameIban("");
      setBeneficiaryNameSwift("");
      setRegNo("");
      setBankAccountNumber("");
      setCountryCode("");
      setAbaRoutingNumber("");
      setCalculatedIBAN("");
      setCalculatedBankData(null);
      setEnableSubmit(false);
      setIsIbanValidated(false);
      setIsABARoutningNumberValidated(false);
      setIsRegnoAccountValidated(false);
      setIsBicValidated(false);
      reset();
      setPurpose(null);
      setAccountType("");
      setCurrency(defaultCurrency);
    } catch (error) {
      console.error("Error submitting bank data:", error);
      const responseErrors = error?.response?.data?.errors;
      if (Array.isArray(responseErrors) && responseErrors.length > 0) {
        responseErrors.forEach((e) => addAlert(e.message || "Invalid value.", "danger"));
        return;
      }
      addAlert("Bank data could not be added: " + (error?.message || error), "danger");
    }
  };


  const onSubmit = async (bankDetail) => {

    if (!purpose) {
      addAlert("Please select a purpose from the dropdown before adding a bank detail.", "error");
      return;
    }

    bankDetail.type = paymentType;
    bankDetail.regNo = regNo;

    if (paymentType === paymentTypes.REGNOACCOUNT) {
      bankDetail.bankAccountNumber = bankAccountNumber;
      if (calculatedIBAN) {
        bankDetail.iban = calculatedIBAN;
      }
      if (calculatedBankData) {
        bankDetail.bank = calculatedBankData.bank;
        bankDetail.address = calculatedBankData.address;
        bankDetail.city = calculatedBankData.city;
        bankDetail.zip = calculatedBankData.zip;
        bankDetail.bic = calculatedBankData.bic;
        bankDetail.countryCode = calculatedBankData.countryIso;
      }
      // Set default currency to DKK for Danish accounts and default beneficiary
      const dkkCurrency = availableCurrencyList.find(c => c.currencyCode === "DKK");
      if (dkkCurrency) {
        bankDetail.currencyId = dkkCurrency.id;
      }
      bankDetail.purpose = purpose;
    }

    if (!validateForm(bankDetail)) {
      return;
    }
    // bankData.keepThisOnly = keepThisOnly;
    const selectedBeneficiaryName =
      paymentType === paymentTypes.IBAN ? beneficiaryNameIban
        : paymentType === paymentTypes.SWIFT ? beneficiaryNameSwift : "";

    bankDetail.beneficiaryBankAccountName = selectedBeneficiaryName?.trim();
    bankDetail.token = token;
    bankDetail.requestId = request.Id || request.id;
    // bankData.currencyId = parseInt(bankData.currencyId, 10);
    bankDetail.abaRoutingNumber = abaRoutingNumber;

    if (paymentType !== paymentTypes.REGNOACCOUNT) {
    }

    if (paymentType === paymentTypes.IBAN) {
      bankDetail.iban = bankDetail.bankAccountNumber;
    }

    // // Add country code for IBAN, ABA and SWIFT payments
    if (paymentType === paymentTypes.IBAN || paymentType === paymentTypes.SWIFT || paymentType === paymentTypes.ABARoutingNumber) {
      bankDetail.countryCode = countryCode;
      bankDetail.purpose = purpose;
    }

    try {
      const result = await trackPromise(apiPostBankDetail(bankDetail, token));
      const newBankData = result.data.bankData || result.data;
      setBankDetailList([...bankDetailList, newBankData]);

      addAlert("Bank data added successfully!", "success");

      // Reset form after successful submission
      setKeepThisOnly(false);
      setBeneficiaryNameIban("");
      setBeneficiaryNameSwift("");
      setRegNo("");
      setBankAccountNumber("");
      setCountryCode("");
      setAbaRoutingNumber("");
      setCalculatedIBAN("");
      setCalculatedBankData(null);
      setEnableSubmit(false);
      setIsIbanValidated(false);
      setIsABARoutningNumberValidated(false);
      setIsRegnoAccountValidated(false);
      setIsBicValidated(false);
      reset();
      setPurpose(null);
      setCurrency(defaultCurrency);
    } catch (error) {
      console.error("Error submitting bank data:", error);
      addAlert("Bank data could not be added: " + error, "error");
    }
  };

  // Helper function to validate and show alert if form is invalid
  const validateForm = (bankDetail) => {

    const valid = (validation) => {
      if (!validation.isValid) {
        addAlert(validation.message, "error");
        return false;
      }
      return true;
    };

    if (paymentType === paymentTypes.REGNOACCOUNT) {
      const missingFields = Validate.requiredFieldsForRegnoAccount(
        bankDetail.regNo,
        bankDetail.bankAccountNumber
      );

      if (missingFields.length > 0) {
        const missingFieldsText = missingFields.join(", ");
        addAlert(`Please fill in the following required fields: ${missingFieldsText}`, "error");
        setIsRegNoValid(!missingFields.includes("Registration Number"));
        setIsBankAccountNumberValid(!missingFields.includes("Account Number"));
        return false;
      }

      const registrationNumberLength = Validate.exactLength(bankDetail.regNo, 4, "Registration number");
      if (!registrationNumberLength.isValid) {
        addAlert(registrationNumberLength.message, "error");
        return false;
      }

      return true;
    }

    if (paymentType === paymentTypes.ABARoutingNumber) {
      const missingFields = Validate.requiredFieldsForABAAdd(
        bankDetail.currencyId,
        bankDetail.accountType,
        bankDetail.bankAccountNumber,
        bankDetail.beneficiaryBankAccountName,
        bankDetail.abaRoutingNumber
      );

      if (!purpose) {
        missingFields.push("Purpose");
      }

      if (missingFields.length > 0) {
        const missingFieldsText = missingFields.join(", ");
        addAlert(`Please fill in the following required fields: ${missingFieldsText}`, "error");
        return false;
      }

      return true;
    }


    const iban = Validate.iban(paymentType, bankDetail.bankAccountNumber);
    if (!valid(iban)) return false;

    const swiftAccountNumber = Validate.swiftAccountNumber(paymentType, bankDetail.bankAccountNumber);
    if (!valid(swiftAccountNumber)) return false;

    const hyphenValidation = Validate.noHyphens(bankDetail.bankAccountNumber, "Account Number");
    if (!valid(hyphenValidation)) return false;


    // Validate registration number requirement
    if (showRegNo) {
      const registrationNumber = Validate.required(regNo?.trim(), "Registration Number");
      if (!valid(registrationNumber)) {
        setIsRegNoValid(false);
        return false;
      }
    }

    if (showRegNo) {
      const accountNumber = Validate.length(bankDetail.bankAccountNumber, accountNumberLength, "Account Number");
      if (!valid(accountNumber)) return false;
    }

    if (showRegNo && accountNumberPattern.test(bankDetail.bankAccountNumber) &&
      (bankDetail?.regNo?.length !== 4 || regNo?.length !== 4)) {
      const registrationNumber = Validate.exactLength(regNo, 4, "Registration number");
      if (!valid(registrationNumber)) return false;
    }

    // Get current beneficiary name
    const currentBeneficiaryName =
      paymentType === paymentTypes.IBAN
        ? beneficiaryNameIban
        : paymentType === paymentTypes.SWIFT
          ? beneficiaryNameSwift
          : bankDetail.beneficiaryBankAccountName;

    const beneficiaryName = Validate.noAmpersands(currentBeneficiaryName, "Beneficiary Name");
    if (!valid(beneficiaryName)) return false;

    const beneficiaryNamePattern = Validate.pattern(
      currentBeneficiaryName || "",
      beneficiaryPattern, "Only alphanumeric characters Abc-Xyz or 0-9 and special character (.,) are allowed by bank(s)."
    );
    if (!valid(beneficiaryNamePattern)) return false;

    // Validate that SWIFT and Corresponding BIC SWIFT are not the same
    if (paymentType === paymentTypes.SWIFT) {
      const swift = document.querySelector('input[name="bic"]')?.value?.trim();
      const correspondingBICSWIFT = document.querySelector('input[name="correspondingBic"]')?.value?.trim();

      const swiftFieldsUnique = Validate.uniqueValues(
        [swift, correspondingBICSWIFT],
        ["SWIFT", "Corresponding BIC SWIFT"]
      );
      if (!valid(swiftFieldsUnique)) return false;
    }

    return true;
  };

  const onDeleteBankDetail = async (bankDetail) => {
    setSelectedBankDetail(bankDetail);
    setToggleConfirmDelete(!toggleConfirmDelete);
  };


  const onConfirmDeleteBankDetail = async () => {
    try {
      // Find all files associated with this bank data
      const files = fileList.filter(file => file.bankDataId === selectedBankDetail.id);

      for (const file of files) {
        try {
          await apiDeleteFile(token, file.fileName);
        } catch (error) {
          console.error(`Error deleting file ${file.fileName}:`, error);
        }
      }

      await apiDeleteBankDetail(token, selectedBankDetail.id);

      setBankDetailList(
        bankDetailList.filter((bank) => bank.id !== selectedBankDetail.id)
      );
      setFileList(
        fileList.filter((file) => file.bankDataId !== selectedBankDetail.id)
      );

      const numberOfFiles = files.length;
      const bankInfo = `${selectedBankDetail.type || "Unknown Type"}${selectedBankDetail.currency?.currencyCode ? ` (${selectedBankDetail.currency.currencyCode})` : ""}`;

      const message = numberOfFiles > 0
        ? `Bank detail ${bankInfo} and ${numberOfFiles} associated file${numberOfFiles > 1 ? 's' : ''} deleted successfully!`
        : `Bank detail ${bankInfo} deleted successfully!`;

      addAlert(message, "success");
    } catch (error) {
      console.error("Error deleting bank data:", error);
      addAlert("Error deleting bank data. Please try again. " + error, "error");
    }
  };


  const viewBankDetail = (bankDetail) => {
    setSelectedBankDetail(bankDetail);
    setViewModalOpen(true);
  };


  return (
    <Container>
      <Alerts alerts={alerts} setAlerts={setAlerts} />

      <EmployeeInformation
        register={register}
        alerts={alerts}
        setAlerts={setAlerts}
        countryList={sortedCountryList}
        selectedCountry={selectedCountry}
        setSelectedCountry={setSelectedCountry}
        setValue={setValue}
        getValues={getValues}
        token={token}
        employee={employee}
        isExistingEmployee={!!employee?.isExistingEmployee}
        errors={errors}
        trigger={trigger}
      />

      <BankDetails
        employeeLoaded={employeeLoaded}
        handleSubmit={handleSubmit}
        onSubmit={addBankData}
        alerts={alerts}
        setAlerts={setAlerts}
        purpose={purpose}
        setPurpose={setPurpose}
        purposeOption={purposeOption}
        register={register}
        paymentType={paymentType}
        setPaymentType={setPaymentType}
        errors={errors}
        setError={setError}
        clearErrors={clearErrors}
        setValue={setValue}
        getValues={getValues}
        watch={watch}
        enableSubmit={enableSubmit}
        setEnableSubmit={setEnableSubmit}
        isBankAccountNumberValid={isBankAccountNumberValid}
        setIsBankAccountNumberValid={setIsBankAccountNumberValid}
        isBICValid={isBICValid}
        setIsBICValid={setIsBICValid}
        isCorrespondingBICValid={isCorrespondingBICValid}
        setIsCorrespondingBICValid={setIsCorrespondingBICValid}
        token={token}
        onGetIBAN={onGetIBAN}
        resetMetadata={resetMetadata}
        handleAccountNo={handleAccountNo}
        showRegNo={showRegNo}
        beneficiaryNameIban={beneficiaryNameIban}
        onBeneficiaryNameChangeIban={onBeneficiaryNameChangeIban}
        isIbanValidated={isIbanValidated}
        countryCode={countryCode}
        setCountryCode={setCountryCode}
        availableCurrencyList={availableCurrencyList}
        sortedCurrencyList={sortedCurrencyList}
        currency={currency}
        onCurrencyChanged={onCurrencyChanged}
        keepThisOnly={keepThisOnly}
        setKeepThisOnly={setKeepThisOnly}
        regNo={regNo}
        setRegNo={setRegNo}
        isRegNoValid={isRegNoValid}
        setIsRegNoValid={setIsRegNoValid}
        bankAccountNumber={bankAccountNumber}
        accountNumberLength={accountNumberLength}
        isFinanceAccount={isFinanceAccount}
        beneficiaryNameSwift={beneficiaryNameSwift}
        onBeneficiaryNameChangeSwift={onBeneficiaryNameChangeSwift}
        handleOnChangeRegistrationNo={handleOnChangeRegistrationNo}
        onGetBIC={onGetBIC}
        isBicValidated={isBicValidated}
        isABARoutningNumberValidated={isABARoutningNumberValidated}
        onGetABARoutingNumber={onGetABARoutingNumber}
        isRegnoAccountValidated={isRegnoAccountValidated}
        onValidateRegnoAccount={onValidateRegnoAccount}
        accountType={accountType}
        setAccountType={setAccountType}
        accountTypeOptions={accountTypeOptions}
        bankDataList={bankDetailList}
        viewBankData={viewBankDetail}
        onDeleteBankData={onDeleteBankDetail}
        countryList={sortedCountryList}
      />

      <AttachFiles
        bankDataList={bankDetailList}
        accountId={request.id}
        fileList={fileList}
        setFileList={setFileList}
        token={token}
        addAlert={addAlert}
      />

      <ViewBankDetailsModal
        isOpen={viewModalOpen}
        toggle={() => setViewModalOpen(!viewModalOpen)}
        selectedBankDetail={selectedBankDetail}
      />

      <Confirm
        onConfirm={onConfirmDeleteBankDetail}
        text={`Are you sure you want to delete this bank account${selectedBankDetail ? ` (${[selectedBankDetail.type, selectedBankDetail.purpose, selectedBankDetail.currency?.currencyCode].filter(Boolean).join(" – ")})` : ""}?`}
        toggle={toggleConfirmDelete}
        setToggle={setToggleConfirmDelete}
      />

      <Confirm
        onConfirm={completeForm}
        text="Submit this form to Hafnia? Once submitted you will not be able to make further changes."
        toggle={toggleConfirmSubmit}
        setToggle={setToggleConfirmSubmit}
      />


      <button
        type="button"
        className="emp-submit-btn"
        onClick={onSubmitClick}
        disabled={isSubmitting}
      >
        <FontAwesomeIcon icon={faCheck} />
        Submit Form
      </button>

      <LoadingIndicator showLoading={!employeeLoaded} />

    </Container>
  );
};

export default Home;
